import React from "react";

import ApplicationContextProvider from "src/context";
import GlobalContextProvider from "../context/GlobalContext"; // TODO - remove this "global" context
import StandardLayout from "src/layouts/standard";
import CookiesManager from "src/components/cookiesManager";

import { isSafari } from "../utils/device";
import LoginModalWatcher from "./loginModalWatcher";
import Styling from "src/layouts/components/styling/styling";
import { addListener, removeListener } from "src/utils/events";
import { restoreScrollPosition, storeScrollPosition } from "src/utils/scroll";
import { getCurrentUri } from "src/utils/history";
import { goToAnchor } from "src/utils/layout";

/**
 * Lazy loads the layout component (except standard layout)
 * @param {string} identifier
 * @returns
 */
function getLayoutComponent(identifier, layout) {
  if (!identifier) return StandardLayout;
  if (identifier === "gausta") return React.lazy(() => import("./gausta"));
  if (layout && layout.navigation_bar) return StandardLayout;
  if (identifier === "moreyspiers") return React.lazy(() => import("./moreyspiers"));
  if (identifier === "default") return React.lazy(() => import("./default"));
  if (identifier === "empty") return React.lazy(() => import("./empty"));
  if (identifier === "aramon") return React.lazy(() => import("./aramon"));
  if (identifier === "haute-garonne") return React.lazy(() => import("./hauteGaronne"));
  if (identifier === "spotlio") return React.lazy(() => import("./spotlioMeta/spotlioMeta"));
  if (identifier === "bjorli") return React.lazy(() => import("./bjorli"));
  if (identifier === "gausta-sesongkort") return React.lazy(() => import("./gaustaSesongkort"));
  if (identifier === "gaustablikk") return React.lazy(() => import("./gaustablikk"));
  if (identifier === "crans-montana") return React.lazy(() => import("./cransMontana/cransMontana"));
  if (identifier === "turufjell") return React.lazy(() => import("./turufjell"));
  if (identifier === "tyinfilefjell") return React.lazy(() => import("./tyinfilefjell"));
  if (identifier === "tyinfilefjell-lite") return React.lazy(() => import("./tyinfilefjellLite"));
  if (identifier === "skibig3") return React.lazy(() => import("./skibig3"));
  if (identifier === "gaustatoppen") return React.lazy(() => import("./gaustatoppen"));
  if (identifier === "workatmoreys") return React.lazy(() => import("./workatmoreys"));
  return ({children}) => children;
}

export class LayoutClass extends React.Component {

  identifier = (() => {
    const { pageContext } = this.props;
    const identifier = pageContext?.layout
      ? typeof pageContext.layout === 'string'
        ? pageContext.layout
        : pageContext.layout.identifier
      : 'empty';
    return identifier;
  })();

  getInnerProps(){
    const { pageContext, location } = this.props;
    return {
      language: pageContext.language,
      destinationId: pageContext.destinationId,
      defaultLanguage: pageContext.defaultLanguage,
      defaultCurrency: pageContext.defaultCurrency,
      pageContext,
      location,
    };
  }

  LayoutComponent = getLayoutComponent(this.identifier, this.props.pageContext?.layout);

  componentDidMount() {
    if (!restoreScrollPosition(getCurrentUri())) goToAnchor();
    addListener('scroll', this.storeScrollPosition)
  }

  storeScrollPosition = (ev) => {
    storeScrollPosition(getCurrentUri());
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.uri !== this.props.uri) {
      if (!restoreScrollPosition(getCurrentUri())) goToAnchor();
    }
  }

  componentWillUnmount() {
    removeListener('scroll', this.storeScrollPosition);
  }

  render() {
    const { children, pageContext } = this.props;
    const layout = this.props.pageContext?.layout;
    const safari = isSafari() ? 'safari-browser' : '';
    const LayoutComponent = this.LayoutComponent;
    const props = this.getInnerProps();
    const cookies = pageContext.cookies || {};

    return (
      <ApplicationContextProvider
        language={pageContext.language}
        defaultLanguage={pageContext.defaultLanguage}
        defaultCurrency={pageContext.defaultCurrency}
        destinationId={pageContext.destinationId}
        isInApp={pageContext.isInApp}
      >
      <GlobalContextProvider>
        {layout ? <Styling layout={layout} className="mainapp" /> : null}
        <main className={[this.identifier, safari, 'mainapp'].join(' ')} lang={pageContext.language}>
          <React.Suspense>
            <LayoutComponent {...props}>
              {children}
              <LoginModalWatcher {...props} />
            </LayoutComponent>
          </React.Suspense>
        </main>
      </GlobalContextProvider>
      <CookiesManager
        language={pageContext.language}
        cookieYesId={cookies.cookieYes}
        cookieInfo={this.identifier === 'gausta'}
      />
      </ApplicationContextProvider>
    );
  }
}

export default LayoutClass;
